// extracted by mini-css-extract-plugin
export default {"container":"cjs4ltt2g","Default":"cmowij85f","input":"cnj9d467z","box":"ck3toqy8x","checked":"cdl0i5u63","text":"cwme92ade","disabled":"co3x8lljn","error":"cy4wgrjj1"};